import {FACTIONS} from "../../../constants/factions";

export const DEMONS_QUOTES = [{
  quote: 'Враг, который видел нас вблизи, уже не враг. Он — часть земли, которую мы топчем',
  author: 'Малакар Пожиратель Взглядов, древний демон-легионер',
  factionId: FACTIONS.DEMONS
}, {
  quote: 'Мы не берём пленных. Пленные — те, кто успел закрыть глаза до того, как мы подошли',
  author: 'Белиал Тартар, архидемон-префект Сломленных знамен',
  factionId: FACTIONS.DEMONS
}, {
  quote: 'В ужасе враг не бежит. Он стоит и смотрит. И молится. Но боги уже не слышат',
  author: 'Адрамелек Молох, верховный демон-легат Ужасающих когорт',
  factionId: FACTIONS.DEMONS
}, {
  quote: 'Трус умирает сотню раз еще до того, как наши когти разорвут его плоть',
  author: 'Ксол Азмодей, демон-децемвир Кровавой бойни ',
  factionId: FACTIONS.DEMONS
}]